// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"33":"widgets","539":"page-settings","571":"settings","820":"my-domain","957":"event-settings"}[chunkId] || chunkId) + ".min.js";
};